import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  transition: 0.5s width ease-in-out;
  overflow: hidden;
`;

export const MainContent = styled.div`
  margin: 1rem;
`;
